import { render, staticRenderFns } from "./index_h5.vue?vue&type=template&id=df83fe86&scoped=true"
import script from "./index_h5.vue?vue&type=script&lang=js"
export * from "./index_h5.vue?vue&type=script&lang=js"
import style0 from "./index_h5.vue?vue&type=style&index=0&id=df83fe86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df83fe86",
  null
  
)

export default component.exports